import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { AlertBaselineResponse } from '@/types/alertDetail';

/**
 * GET /api/v1/alerts/{id}/baseline-comparison
 *
 * Returns vehicle-own / peer-cohort / OEM baseline slices side-by-side
 * for the BaselineComparisonSection. All three sub-objects are present
 * but every leaf field can be null when no data is available.
 */
export function useAlertBaseline(
  alertId: number | undefined,
): UseQueryResult<AlertBaselineResponse, Error> {
  return useQuery<AlertBaselineResponse, Error>({
    queryKey: ['alert', alertId, 'baseline'],
    enabled: alertId != null,
    queryFn: async () => {
      const resp = await api.get<AlertBaselineResponse>(
        `/alerts/${alertId}/baseline-comparison`,
      );
      return resp.data;
    },
  });
}
